import { DialogButton } from '@beeinventor/dasiot-react-component-lib';

const CheckErrorButton = ({
  isPassed,
  isChecked,
  setIsPassed,
  setIsChecked,
}: {
  isPassed: boolean | undefined;
  isChecked: boolean | undefined;
  setIsPassed: (state: boolean) => void;
  setIsChecked: (state: boolean) => void;
}) => {
  // Function to check error elements
  function checkForErrors() {
    const potentialErrorElements = document.getElementsByTagName('img');
    const checks = Array.from(potentialErrorElements).filter(
      (d) => d.getAttribute('alt')?.includes('error') ?? false,
    );
    if (checks.length > 0) {
      setIsPassed(false);
    } else {
      setIsPassed(true);
    }
  }

  // Create a MutationObserver to watch for changes in the DOM
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' || mutation.type === 'attributes') {
        checkForErrors();
      }
    }
  });

  // Start observing the document for changes
  observer.observe(document.body, {
    attributes: true,
    childList: true,
    subtree: true,
  });

  // Initial check
  checkForErrors();

  return (
    <>
      <DialogButton
        disabled={!isPassed}
        variant="contained"
        color="primary"
        onClick={() => {
          setIsChecked(!isChecked);
        }}
        sx={{
          margin: '0 auto',
        }}
      >
        CHECK
        <span
          style={{
            display: 'flex',
            justifyContent: 'center',
            paddingLeft: '5px',
          }}
        ></span>
      </DialogButton>
    </>
  );
};

export default CheckErrorButton;
